// import React from 'react';
// import { Card, CardHeader, Heading, CardBody, useColorModeValue, useColorMode, Box, Text } from '@chakra-ui/react';
// import ReactApexChart from 'react-apexcharts';

// const ProfitabilityByCustomerChart = ({ data, title = 'Profitability by Customer', height = 400 }) => {
//    // Color mode values must be declared at the top
//    const { colorMode } = useColorMode();
//    const textColor = useColorModeValue('gray.800', 'white');
//    const chartBg = useColorModeValue('white', 'gray.700');
//    const gridColor = useColorModeValue('#E2E8F0', '#4A5568');
//    const tooltipBg = useColorModeValue('#FFFFFF', '#2D3748');
//    const tooltipTextColor = useColorModeValue('#1A202C', '#F7FAFC');

//    // Define color schemes for both modes
//    const segmentColors = {
//       light: {
//          'HIGH VALUE': '#38A169',
//          'MEDIUM VALUE': '#ECC94B',
//          'LOW VALUE': '#E53E3E',
//          default: '#3182CE',
//       },
//       dark: {
//          'HIGH VALUE': '#68D391',
//          'MEDIUM VALUE': '#F6E05E',
//          'LOW VALUE': '#FC8181',
//          default: '#63B3ED',
//       },
//    };

//    const getBarColor = (segment) => {
//       const colors = colorMode === 'light' ? segmentColors.light : segmentColors.dark;
//       return colors[segment] || colors['default'];
//    };

//    if (!data || data.length === 0) {
//       return (
//          <Card h={height} bg={chartBg}>
//             <CardHeader>
//                <Heading size="md" color={textColor}>
//                   {title}
//                </Heading>
//             </CardHeader>
//             <CardBody>
//                <Box display="flex" alignItems="center" justifyContent="center" height="100%">
//                   <Text color={textColor}>No data available</Text>
//                </Box>
//             </CardBody>
//          </Card>
//       );
//    }

//    // Sort by net_sales descending
//    const sortedData = [...data].sort((a, b) => b.net_sales - a.net_sales);

//    const categories = sortedData.map((item) => item.customer_name);
//    const seriesData = sortedData.map((item) => item.net_sales);
//    const tooltipData = sortedData.map((item) => ({
//       customer_name: item.customer_name,
//       segment: item.customer_segment,
//       avg_transaction_value: item.avg_transaction_value,
//       transactions: item.total_transactions,
//    }));

//    const colors = sortedData.map((item) => getBarColor(item.customer_segment));

//    const options = {
//       chart: {
//          type: 'bar',
//          toolbar: { show: false },
//          background: chartBg,
//          foreColor: textColor,
//       },
//       plotOptions: {
//          bar: {
//             horizontal: true,
//             borderRadius: 4,
//             barHeight: '50%',
//          },
//       },
//       dataLabels: {
//          enabled: false,
//       },
//       xaxis: {
//          title: {
//             text: 'Net Sales (₹)',
//             style: {
//                color: textColor,
//             },
//          },
//          labels: {
//             formatter: (val) => '₹' + val.toLocaleString('en-IN'),
//             style: {
//                colors: textColor,
//             },
//          },
//          axisBorder: {
//             color: gridColor,
//          },
//          axisTicks: {
//             color: gridColor,
//          },
//       },
//       yaxis: {
//          categories,
//          labels: {
//             style: {
//                colors: textColor,
//             },
//          },
//       },
//       tooltip: {
//          custom: ({ dataPointIndex }) => {
//             const d = tooltipData[dataPointIndex];
//             return `
//           <div style="padding:8px; background:${tooltipBg}; color:${tooltipTextColor}; border-radius:4px">
//             <strong>Avg Txn Value:</strong> ₹${Number(d.avg_transaction_value).toLocaleString('en-IN')}<br/>
//             <strong>Customer:</strong> ${d.customer_name}<br/>
//             <strong>Transactions:</strong> ${d.transactions}<br/>
//             <strong>Segment:</strong> ${d.segment}
//           </div>
//         `;
//          },
//       },
//       fill: {
//          colors,
//       },
//       grid: {
//          borderColor: gridColor,
//          strokeDashArray: 4,
//          xaxis: {
//             lines: {
//                show: true,
//             },
//          },
//          yaxis: {
//             lines: {
//                show: false,
//             },
//          },
//       },
//    };

//    const series = [
//       {
//          name: 'Net Sales',
//          data: seriesData,
//       },
//    ];

//    return (
//       <Card h={height} bg={chartBg}>
//          <CardHeader>
//             <Heading size="md" color={textColor}>
//                {title}
//             </Heading>
//          </CardHeader>
//          <CardBody>
//             <ReactApexChart options={options} series={series} type="bar" height={height - 80} />
//          </CardBody>
//       </Card>
//    );
// };

// export default ProfitabilityByCustomerChart;

import React, { useState } from 'react';
import { useColorMode } from '@chakra-ui/react';
import ReactApexChart from 'react-apexcharts';
import { RotateCw } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { getProfitabilityAnalysisByCustomer } from '../../../../redux/actions/dashboard';

const ProfitabilityByCustomerChart = ({ data, title = 'Profitability by Customer', height = 400, financialAnalysisDateRange, user }) => {
   // Color mode detection
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [isRotating, setIsRotating] = useState(false);
   const dispatch = useDispatch();

   // Define color schemes for both modes
   const segmentColors = {
      light: {
         'HIGH VALUE': '#38A169',
         'MEDIUM VALUE': '#ECC94B',
         'LOW VALUE': '#E53E3E',
         default: '#3182CE',
      },
      dark: {
         'HIGH VALUE': '#68D391',
         'MEDIUM VALUE': '#F6E05E',
         'LOW VALUE': '#FC8181',
         default: '#63B3ED',
      },
   };

   const getBarColor = (segment) => {
      const colors = isDark ? segmentColors.dark : segmentColors.light;
      return colors[segment] || colors['default'];
   };

   if (!data || data.length === 0) {
      return (
         <div
            className={`rounded-lg shadow-md ${isDark ? 'bg-gray-700' : 'bg-white'}`}
            style={{ height: `${height}px` }}>
            <div className="p-6">
               <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>{title}</h2>
            </div>
            <div className="p-6 flex items-center justify-center h-full">
               <p className={isDark ? 'text-white' : 'text-gray-800'}>No data available</p>
            </div>
         </div>
      );
   }

   // Sort by net_sales descending
   const sortedData = [...data].sort((a, b) => b.net_sales - a.net_sales);

   const categories = sortedData.map((item) => item.customer_name);
   const seriesData = sortedData.map((item) => item.net_sales);
   const tooltipData = sortedData.map((item) => ({
      customer_name: item.customer_name,
      segment: item.customer_segment,
      avg_transaction_value: item.avg_transaction_value,
      transactions: item.total_transactions,
   }));

   const colors = sortedData.map((item) => getBarColor(item.customer_segment));

   // Dynamic colors based on theme
   const textColor = isDark ? '#FFFFFF' : '#1A202C';
   const chartBg = isDark ? '#374151' : '#FFFFFF';
   const gridColor = isDark ? '#4A5568' : '#E2E8F0';
   const tooltipBg = isDark ? '#2D3748' : '#FFFFFF';
   const tooltipTextColor = isDark ? '#F7FAFC' : '#1A202C';

   const options = {
      chart: {
         type: 'bar',
         toolbar: { show: false },
         background: chartBg,
         foreColor: textColor,
      },
      plotOptions: {
         bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: '50%',
         },
      },
      dataLabels: {
         enabled: false,
      },
      xaxis: {
         title: {
            text: 'Net Sales (₹)',
            style: {
               color: textColor,
            },
         },
         labels: {
            formatter: (val) => '₹' + val.toLocaleString('en-IN'),
            style: {
               colors: textColor,
            },
         },
         axisBorder: {
            color: gridColor,
         },
         axisTicks: {
            color: gridColor,
         },
      },
      yaxis: {
         categories,
         labels: {
            style: {
               colors: textColor,
            },
         },
      },
      tooltip: {
         custom: ({ dataPointIndex }) => {
            const d = tooltipData[dataPointIndex];
            return `
          <div style="padding:8px; background:${tooltipBg}; color:${tooltipTextColor}; border-radius:4px">
            <strong>Avg Txn Value:</strong> ₹${Number(d.avg_transaction_value).toLocaleString('en-IN')}<br/>
            <strong>Customer:</strong> ${d.customer_name}<br/>
            <strong>Transactions:</strong> ${d.transactions}<br/>
            <strong>Segment:</strong> ${d.segment}
          </div>
        `;
         },
      },
      fill: {
         colors,
      },
      grid: {
         borderColor: gridColor,
         strokeDashArray: 4,
         xaxis: {
            lines: {
               show: true,
            },
         },
         yaxis: {
            lines: {
               show: false,
            },
         },
      },
   };

   const series = [
      {
         name: 'Net Sales',
         data: seriesData,
      },
   ];

   const handleReload = async () => {
      setIsRotating(true);
      dispatch(
         getProfitabilityAnalysisByCustomer({
            companyId: user?.loginhistory?.companyId,
            fromDate: financialAnalysisDateRange.fromDate,
            toDate: financialAnalysisDateRange.toDate,
         }),
      );
      setTimeout(() => setIsRotating(false), 700);
   };

   return (
      <div className={`rounded-lg shadow-md ${isDark ? 'bg-gray-700' : 'bg-white'}`} style={{ height: `${height}px` }}>
         <div className="p-6 flex items-center gap-3 border-b">
            <div className={`w-1 h-8 rounded-full ${isDark ? 'bg-rose-500' : 'bg-rose-400'}`}></div>
            <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>{title}</h2>
            <button
               onClick={handleReload}
               className={`ml-auto p-2 rounded-full transition-all hover:scale-110 ${isDark ? "hover:bg-gray-600 text-blue-400" : "hover:bg-gray-100 text-blue-600"
                  }`}
            >
               <RotateCw
                  className={`w-5 h-5 transform ${isRotating ? "rotate-[360deg]" : ""
                     } transition-transform ease-in-out`}
                  style={{
                     transitionDuration: isRotating ? "700ms" : "10ms",
                  }}
               />
            </button>
         </div>
         <div className="p-6">
            <ReactApexChart options={options} series={series} type="bar" height={height - 80} />
         </div>
      </div>
   );
};

export default ProfitabilityByCustomerChart;
